import React, {useState, useContext} from "react";
import axios from "axios";
import Avatar from 'react-avatar-editor'
import {getApiSitePrefix} from "../functions/SiteDefaults";
import SystemContext from "../SystemContext";
import {Grid} from "@material-ui/core";
import Button from "@material-ui/core/Button";

const apiSitePrefix = getApiSitePrefix();

const AvatarEdit = (props) => {

  const [state, setState] = useState({
    preview: props.newUser ? "images/DefaultAvatar.png" : null,
    src: props.newUser ? null : props.src,
    url: null,
    clearAvatar: props.newUser,
    editing: props.newUser
  });
  const SystemData = useContext(SystemContext);

  const uploadAvatarToS3 = async () => {
    const headers = {...axios.defaults.headers, 'Content-Type': 'application/json'};
    try {
      const response = await axios.post(
        `${apiSitePrefix}/useravatar/upload/${props.user}/${state.fileName}`,
        { document: JSON.stringify(state.preview) },
        { headers }
      );

      if (response && response.data) {
        if (response.data.status) {
          setState({...state, url: response.data.url});
          SystemData.openAlert("Avatar Upload", "Avatar image Upload completed successfully");
          return (response.data.url);
        } else {
          SystemData.openAlert("Avatar Upload Error", "The Avatar image failed to upload with this error: " + response.data.error);
        }
      } else {
        SystemData.openAlert("Avatar Upload Error", "The Avatar image failed to upload due to an unknown error");
      }
    } catch (err) {
      console.error(err);
      SystemData.openAlert("Avatar Upload Error", "The Avatar image failed to upload with this error: " + err);
    }

    return "";
  }

  const onClose = async () => {
    const avatar = await uploadAvatarToS3();
    if (props.onChange && avatar !== "") {
      props.onChange(avatar);
    }
    setState({...state, editing: false, clearAvatar: false});
  }

  const onCrop = (preview) => {
    setState({...state, preview})
  }

  const onImageLoad = (image) => {

  }

  const onBeforeFileLoad = (elem) =>{
    if(elem.target.files[0].size > (1024 * 1024)){
      SystemData.openAlert("File Size Error", "Avatar image size cannot be bigger than 1MB");
      elem.target.value = "";
      return;
    };
    setState({...state, fileName: elem.target.files[0].name})
  }

  const handleClick = async (action) => {
    switch (action) {
      case "edit":
        setState({...state, editing: true, clearAvatar: false});
        break;
      case "clear":
        if (state.clearAvatar) {
          setState({...state, clearAvatar: false, src: null, preview: "images/DefaultAvatar.png"});
        }
        else
          setState({...state, clearAvatar: true, src: null, preview: "images/DefaultAvatar.png"});
        break;
      case "save":
        await onClose()
        break;
      default:
    }
  }

  const avatarProps = {
    src: state.src,
    label: "Choose Avatar File",
    width: props.width || 400,
    height: props.height || 300,
    onCrop: onCrop,
    onClose: onClose,
    onBeforeFileLoad: onBeforeFileLoad,
    onImageLoad: onImageLoad,
    shadingColor: "white",
    backgroundColor: "white",
    closeIconColor: "#27221E",
  }

  return (
    <div style={{display: "flex"}}>
      <Grid container spacing={3}>
        <Grid item xs={5}>
          <Grid container spacing={3} direction="column" align="center">
            <Grid item xs={12}>
              {props.src || state.preview
                ?
                  <img src={state.preview ? state.preview : state.clearAvatar ? null: state.src} alt="Preview" style={{width: props.previewWidth, borderRadius: '50%'}}/>
                :
                <></>
              }
            </Grid>
            <Grid item xs={12}>
              {state.editing
                ? <div>
                    <Button onClick={() => handleClick ("clear") }>Clear</Button>
                    <Button onClick={() => handleClick ("save") }>Save</Button>
                  </div>
                : <Button onClick={() => handleClick ("edit") }>Edit</Button>
              }
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={5}>
          { state.editing && !state.clearAvatar && state.src ? <Avatar {...avatarProps} /> : <></> }
          { state.clearAvatar ? <Avatar {...avatarProps} /> : <></> }
          { !state.clearAvatar && state.src === null ? <Avatar {...avatarProps} /> : <></> }
        </Grid>
      </Grid>
    </div>
  );
}

export default AvatarEdit;